/**
 * Created by mgoria on 2/25/16.
 */

'use strict';

/**
 * Base exception
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Helper = exports.Helper = function () {
  function Helper() {
    _classCallCheck(this, Helper);
  }

  _createClass(Helper, null, [{
    key: 'assureDefinedCode',


    /**
     * @param {String|Number}code
     * @returns {Number}
     */
    value: function assureDefinedCode(code) {
      code = parseInt(code);

      if (Helper.CODES.indexOf(code) !== -1) {
        return code;
      }

      // fallback to a defined error code
      code = parseInt(String(code).charAt(0) + '00');

      return Helper.CODES.indexOf(code) !== -1 ? code : 500;
    }
  }, {
    key: 'CODES',

    /**
     * @returns {Number[]}
     */
    get: function get() {
      return [200, 400, 401, 403, 404, 406, 409, 500];
    }
  }]);

  return Helper;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/HTTP/Helper.js
// module id = 167
// module chunks = 0